<p-dialog
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: 'min(96vw, 1200px)' }"
  [contentStyle]="{ overflow: 'visible' }"
  [header]="title() || ('zip_explorer' | transloco)"
>
  <div class="zip-explorer-layout">
    <div class="zip-explorer-side">
      <div class="zip-explorer-tree">
        @if (isLoadingTree()) {
          <div class="zip-explorer-state">
            <i class="pi pi-spin pi-spinner text-2xl"></i>
            <span>{{ 'loading' | transloco }}</span>
          </div>
        } @else if (errorKey() && !treeNodes().length) {
          <div class="zip-explorer-state">
            <i class="pi pi-exclamation-triangle text-2xl"></i>
            <span>{{ errorKey() | transloco }}</span>
          </div>
        } @else {
          <p-tree
            [value]="treeNodes()"
            selectionMode="single"
            (onNodeSelect)="onNodeSelect($event)"
            styleClass="zip-explorer-p-tree"
          />
        }
      </div>

      <lib-printer-picker />
    </div>

    <div class="zip-explorer-preview">
      @if (isLoadingFile()) {
        <div class="zip-explorer-state">
          <i class="pi pi-spin pi-spinner text-2xl"></i>
          <span>{{ 'loading_pdf' | transloco }}</span>
        </div>
      } @else if (previewUrl()) {
        <lib-app-pdf-viewer
          [pdfSource]="previewUrl()"
          [showToolbar]="false"
          height="65vh"
          customClass="w-full rounded-lg"
        />
      } @else {
        <div class="zip-explorer-state">
          <i class="pi pi-file-pdf text-4xl"></i>
          <span>{{ 'zip_select_file_hint' | transloco }}</span>
        </div>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button [label]="'close' | transloco" severity="secondary" (click)="close()" />
    <p-button
      [label]="'print' | transloco"
      icon="pi pi-print"
      [disabled]="!previewUrl() || isPrinting() || !printerPicker()?.canPrint()"
      [loading]="isPrinting()"
      (click)="print()"
    />
  </ng-template>
</p-dialog>
